import CreateSurveyDialog from './createSurveyDialog.container'

export default CreateSurveyDialog